import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "motion/react";
import { Menu, X, Shield } from "lucide-react";

export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { name: "O nas", href: "#o-nas" },
    { name: "Usługi", href: "#uslugi" },
    { name: "Portfolio", href: "#portfolio" },
    { name: "Kontakt", href: "#kontakt" },
  ];

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? "bg-studio-dark/90 backdrop-blur-md border-b border-zinc-800/50 py-4" : "bg-transparent py-6"
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-8 flex items-center justify-between">
          <a href="#" className="flex items-center gap-2 group focus:outline-none focus:ring-2 focus:ring-studio-gold rounded" aria-label="Strona główna Prestige Detailing">
            <Shield className="text-studio-gold w-8 h-8 group-hover:scale-110 transition-transform duration-300" aria-hidden="true" />
            <div>
              <span className="font-display font-bold text-xl text-white tracking-wide leading-none block">PRESTIGE</span>
              <span className="text-[0.65rem] text-studio-gold uppercase tracking-[0.2em]">Detailing</span>
            </div>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex flex-1 justify-center items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-sm font-medium text-zinc-300 hover:text-studio-gold transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-studio-gold rounded py-2 px-3 inline-flex min-h-[48px] items-center"
              >
                {link.name}
              </a>
            ))}
          </nav>

          <div className="hidden md:block">
            <a href="#kontakt" className="px-5 py-2.5 min-h-[48px] inline-flex items-center justify-center text-sm font-medium bg-white text-black hover:bg-zinc-200 rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-studio-gold">
              Umów wizytę
            </a>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            className="md:hidden text-zinc-300 hover:text-white p-3 min-w-[48px] min-h-[48px] flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-studio-gold rounded"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-expanded={isMobileMenuOpen}
            aria-label={isMobileMenuOpen ? "Zamknij menu" : "Otwórz menu"}
          >
            {isMobileMenuOpen ? <X size={24} aria-hidden="true" /> : <Menu size={24} aria-hidden="true" />}
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.2 }}
            className="fixed inset-0 z-40 bg-studio-dark/95 backdrop-blur-xl pt-24 px-6 md:hidden flex flex-col"
          >
            <nav className="flex flex-col gap-6 items-center">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="text-2xl font-display font-medium text-zinc-300 hover:text-studio-gold transition-colors py-2 px-4 inline-flex min-h-[48px] items-center"
                >
                  {link.name}
                </a>
              ))}
              <a 
                href="#kontakt" 
                onClick={() => setIsMobileMenuOpen(false)}
                className="mt-8 px-8 py-4 w-full text-center text-lg font-medium bg-studio-gold text-black rounded-lg min-h-[48px] flex items-center justify-center"
              >
                Umów wizytę
              </a>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
